export function actionState(action, role = "observer") {
  const ready = action?.ready !== false;
  const blocked = !ready;
  const reason = blocked ? action?.reason || "Действие недоступно" : "";
  const mutation = action?.kind === "mutation";
  const readonlyBlocked = mutation && role === "observer";
  return {
    id: action?.id || "",
    label: action?.label || action?.id || "Действие",
    kind: action?.kind || "navigate",
    target: action?.target || "",
    ready: ready && !readonlyBlocked,
    blocked: blocked || readonlyBlocked,
    reason: readonlyBlocked ? "Наблюдатель видит данные без изменений" : reason,
    cssClass: mutation ? "sheet-action-mutation" : "sheet-action-navigation"
  };
}

export function actionsForRole(actions = [], role = "observer") {
  return actions.map((action) => actionState(action, role));
}

export function primarySheetAction(actions = [], role = "observer") {
  return actionsForRole(actions, role).find((action) => action.ready) || actionsForRole(actions, role)[0] || null;
}
